import React, { useState, useEffect, useContext } from "react";
import Select from "react-select";
import { MDBInput } from "mdb-react-ui-kit";
import apiService from "../../../Services/apiServices";
import { useToasts } from "react-toast-notifications";
import { confirmAlert } from "react-confirm-alert";
import helper from "../../../Services/helper";
import globals from "../../../Services/globals";
import UserPermissionContext from "../../Context/UserPermissionContext";

function VatReport(props) {
    useEffect(()=> {
      // getPermissions();
      document.getElementById('navi')?.classList.add("nav-mobile")
      return () => {
        document.getElementById('navi')?.classList.remove("nav-mobile")
      }
    }, [])
  const { addToast } = useToasts();
  const [reports , setReports] = useState();
  const {userPermission} = useContext(UserPermissionContext);
  const reportId = props.match.params.id
  
  const displayMsg = () => {
    addToast( "së shpejti ky raport do të jet aktiv", { appearance: 'info', autoDismiss: true, });
  }

  // const getPermissions = () => {
  //   var params = `&username=${globals().getLogedInUser().data.username}`;
  //   apiService().query('getUserPermissions',params)
  //       .then((response) => {
  //        if(response.success){
  //          setUserPermissions(response.data)
  //        }
  //       })
  // }

    return(
        <div style={{height: "85vh"}} className="container">
        <div className="container-fluid mt-5">
        <div className="row">
          <div className="col-12 mb-4">
            <h4  className="m-0 mt-1 font-weight-bold text-center text-primary ">{helper().translate("VAT")}</h4>
          </div>
            <hr  style={{width: "97%" , margin: "auto" , height: "2px" , color: "black" , backgroundColor: "black"}}></hr>
            <div > 
            <nav className="  header-tools"  >
        <div className=" col-lg-12 p-0" id="myHeader">
          <a href={'#/reportsMap/2'}  className="btn btn-success btn-icon-split btn-sm mt-2 mb-2 mr-2">
            <span className="icon text-white-40">
              <i className="fas fa-arrow-left " />
            </span>
            <span className="text ">{helper().translate('BACK')}</span>
          </a>
       </div>
       </nav>
            </div>
        </div>
        <div className="row mt-2">
        <a  href={`#/report/atk/vat-monthly/1`}
                class={'text-decoration-none text-dark col-xl-4 col-md-6 mb-4  height100  ${userPermission?.find((f)=> f.moduleName === rep.title)?.allowView ? "" : "pe-none"}' }
                >
                 
                <div style={{borderBottom: `4px solid `}}  className="card reportsHover shadow h-100 py-2 ">
                  <div className="card-body">
                    <div className="row w-100 h-100 align-items-center justify-content-center">
                    <h5   className="text-xl text-center font-weight-bold  mb-1">{helper().translate("MONTH")+ helper().translate("JANUARY")}</h5>
                    </div>
                  </div>
                </div>
                </a>
              <a  href={`#/report/atk/vat-monthly/2`}
                class={'text-decoration-none text-dark col-xl-4 col-md-6 mb-4  height100  ${userPermission?.find((f)=> f.moduleName === rep.title)?.allowView ? "" : "pe-none"}' }
                >
                 
                <div style={{borderBottom: `4px solid `}}  className="card reportsHover shadow h-100 py-2 ">
                  <div className="card-body">
                    <div className="row w-100 h-100 align-items-center justify-content-center">
                    <h5   className="text-xl text-center font-weight-bold  mb-1">{helper().translate("MONTH")+ helper().translate("FEBRUARY")}</h5>
                    </div>
                  </div>
                </div>
                </a>
              <a  href={`#/report/atk/vat-monthly/3`}
                class={'text-decoration-none text-dark col-xl-4 col-md-6 mb-4  height100  ${userPermission?.find((f)=> f.moduleName === rep.title)?.allowView ? "" : "pe-none"}' }
                >
                 
                <div style={{borderBottom: `4px solid `}}  className="card reportsHover shadow h-100 py-2 ">
                  <div className="card-body">
                    <div className="row w-100 h-100 align-items-center justify-content-center">
                    <h5   className="text-xl text-center font-weight-bold  mb-1">{helper().translate("MONTH")+ helper().translate("MARCH")}</h5>
                    </div>
                  </div>
                </div>
                </a>
              <a  href={`#/report/atk/vat-monthly/4`}
                class={'text-decoration-none text-dark col-xl-4 col-md-6 mb-4  height100  ${userPermission?.find((f)=> f.moduleName === rep.title)?.allowView ? "" : "pe-none"}' }
                >
                 
                <div style={{borderBottom: `4px solid `}}  className="card reportsHover shadow h-100 py-2 ">
                  <div className="card-body">
                    <div className="row w-100 h-100 align-items-center justify-content-center">
                    <h5   className="text-xl text-center font-weight-bold  mb-1">{helper().translate("MONTH")+ helper().translate("APRILL")}</h5>
                    </div>
                  </div>
                </div>
                </a>
              <a  href={`#/report/atk/vat-monthly/5`}
                class={'text-decoration-none text-dark col-xl-4 col-md-6 mb-4  height100  ${userPermission?.find((f)=> f.moduleName === rep.title)?.allowView ? "" : "pe-none"}' }
                >
                 
                <div style={{borderBottom: `4px solid `}}  className="card reportsHover shadow h-100 py-2 ">
                  <div className="card-body">
                    <div className="row w-100 h-100 align-items-center justify-content-center">
                    <h5   className="text-xl text-center font-weight-bold  mb-1">{helper().translate("MONTH")+ helper().translate("MAY")}</h5>
                    </div>
                  </div>
                </div>
                </a>
              <a  href={`#/report/atk/vat-monthly/6`}
                class={'text-decoration-none text-dark col-xl-4 col-md-6 mb-4  height100  ${userPermission?.find((f)=> f.moduleName === rep.title)?.allowView ? "" : "pe-none"}' }
                >
                 
                <div style={{borderBottom: `4px solid `}}  className="card reportsHover shadow h-100 py-2 ">
                  <div className="card-body">
                    <div className="row w-100 h-100 align-items-center justify-content-center">
                    <h5   className="text-xl text-center font-weight-bold  mb-1">{helper().translate("MONTH")+ helper().translate("JUNE")}</h5>
                    </div>
                  </div>
                </div>
                </a>
              <a  href={`#/report/atk/vat-monthly/7`}
                class={'text-decoration-none text-dark col-xl-4 col-md-6 mb-4  height100  ${userPermission?.find((f)=> f.moduleName === rep.title)?.allowView ? "" : "pe-none"}' }
                >
                 
                <div style={{borderBottom: `4px solid `}}  className="card reportsHover shadow h-100 py-2 ">
                  <div className="card-body">
                    <div className="row w-100 h-100 align-items-center justify-content-center">
                    <h5   className="text-xl text-center font-weight-bold  mb-1">{helper().translate("MONTH")+ helper().translate("JULY")}</h5>
                    </div>
                  </div>
                </div>
                </a>
              <a  href={`#/report/atk/vat-monthly/8`}
                class={'text-decoration-none text-dark col-xl-4 col-md-6 mb-4  height100  ${userPermission?.find((f)=> f.moduleName === rep.title)?.allowView ? "" : "pe-none"}' }
                >
                 
                <div style={{borderBottom: `4px solid `}}  className="card reportsHover shadow h-100 py-2 ">
                  <div className="card-body">
                    <div className="row w-100 h-100 align-items-center justify-content-center">
                    <h5   className="text-xl text-center font-weight-bold  mb-1">{helper().translate("MONTH")+ helper().translate("AUGUST")}</h5>
                    </div>
                  </div>
                </div>
                </a>
              <a  href={`#/report/atk/vat-monthly/9`}
                class={'text-decoration-none text-dark col-xl-4 col-md-6 mb-4  height100  ${userPermission?.find((f)=> f.moduleName === rep.title)?.allowView ? "" : "pe-none"}' }
                >
                 
                <div style={{borderBottom: `4px solid `}}  className="card reportsHover shadow h-100 py-2 ">
                  <div className="card-body">
                    <div className="row w-100 h-100 align-items-center justify-content-center">
                    <h5   className="text-xl text-center font-weight-bold  mb-1">{helper().translate("MONTH")+ helper().translate("SEPTEMBER")}</h5>
                    </div>
                  </div>
                </div>
                </a>
              <a  href={`#/report/atk/vat-monthly/10`}
                class={'text-decoration-none text-dark col-xl-4 col-md-6 mb-4  height100  ${userPermission?.find((f)=> f.moduleName === rep.title)?.allowView ? "" : "pe-none"}' }
                >
                 
                <div style={{borderBottom: `4px solid `}}  className="card reportsHover shadow h-100 py-2 ">
                  <div className="card-body">
                    <div className="row w-100 h-100 align-items-center justify-content-center">
                    <h5   className="text-xl text-center font-weight-bold  mb-1">{helper().translate("MONTH")+ helper().translate("OCTOBER")}</h5>
                    </div>
                  </div>
                </div>
                </a>
              <a  href={`#/report/atk/vat-monthly/11`}
                class={'text-decoration-none text-dark col-xl-4 col-md-6 mb-4  height100  ${userPermission?.find((f)=> f.moduleName === rep.title)?.allowView ? "" : "pe-none"}' }
                >
                 
                <div style={{borderBottom: `4px solid `}}  className="card reportsHover shadow h-100 py-2 ">
                  <div className="card-body">
                    <div className="row w-100 h-100 align-items-center justify-content-center">
                    <h5   className="text-xl text-center font-weight-bold  mb-1">{helper().translate("MONTH")+ helper().translate("NOVEMBER")}</h5>
                    </div>
                  </div>
                </div>
                </a>
              <a  href={`#/report/atk/vat-monthly/12`}
                class={'text-decoration-none text-dark col-xl-4 col-md-6 mb-4  height100  ${userPermission?.find((f)=> f.moduleName === rep.title)?.allowView ? "" : "pe-none"}' }
                >
                 
                <div style={{borderBottom: `4px solid `}}  className="card reportsHover shadow h-100 py-2 ">
                  <div className="card-body">
                    <div className="row w-100 h-100 align-items-center justify-content-center">
                    <h5   className="text-xl text-center font-weight-bold  mb-1">{helper().translate("MONTH")+ helper().translate("DECEMBER")}</h5>
                    </div>
                  </div>
                </div>
                </a>
             

        </div>
        </div>
        </div>
    )
}


export default VatReport;